import { get } from '@/axios'

export type ISuggestKeywordsResponse = {
  list: string[]
}

export const suggestKeywords = async () => {
  const response = await get<ISuggestKeywordsResponse>(`/search/suggestKeywords`)

  return response
}
